import React, { useState, useId, useEffect } from "react";
import { connect } from "react-redux";
import { requests } from "../../axios";
import {
  JOINTS_NOT_FOUND,
  JOINT_INPUT_DEFAULT_OPTION,
  CONCEPTS_NOT_FOUND,
  USERDATA,
} from "../../types";
import {
  getAssemblyJointsRequest,
  getAssemblyConceptsRequest,
} from "../../actions";
import "../../assets/styles/assembly/AssemblyDashboard.css";
import Loading from "../../components/Loading";
import { getStorage } from "../../utils";
import { useFormik } from "formik";

const AssemblyDashboard = (props) => {
  const id = useId();

  const [requestState, setRequestState] = useState({
    loading: true,
    error: null,
  });

  const [registerState, setRegisterState] = useState({
    quorum: "0.0000",
    apartments: 0,
  });

  const [realQuorumState, setRealQuorumState] = useState({
    quorum: "0.0000",
    quantity: 0,
    show: false,
  });

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const fetchData = async () => {
    try {
      if (!props.assemblyJoints.length) {
        const response = await requests.users.getUsersAssemblyJoints(
          props.user.userId || getStorage(USERDATA).userId,
        );
        props.getAssemblyJointsRequest(response.data);
      }
      setRequestState({ ...requestState, loading: false });
    } catch (error) {
      console.log(error.response.status);
      setRequestState({
        loading: false,
        error: JOINTS_NOT_FOUND,
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      jointId: "",
    },
  });

  useEffect(() => {
  if (formik.values.jointId) {
    handleConcepts();
    const intervalId = setInterval(() => {
      handleConcepts();
    }, 10000);
    return () => clearInterval(intervalId);
  }
}, [formik.values.jointId]);

  const handleConcepts = async () => {
    try {
      setRequestState({
        error: null,
      });
      const jointId = document.getElementById("joint").value;
      const data = {
        concept: 1,
        jointId: jointId,
        voteId: 1,
      };
      const coefficient =
        jointId && (await requests.assembly.getCoefficient(data));
      const totalApartments =
        jointId && (await requests.assembly.getTotalApartments(data));
      setRegisterState({
        quorum: coefficient ? coefficient.data.toFixed(4) : 0.0,
        apartments: totalApartments ? totalApartments.data : 0,
      });
      const apartmentsRegistered =
        jointId &&
        (await requests.assembly.getApartmentsRegistered({
          conceptId: 1,
          jointId: jointId,
        }));
      setRealQuorum(apartmentsRegistered.data, totalApartments.data);
    } catch (error) {
      setRequestState({
        error: CONCEPTS_NOT_FOUND,
      });
    }
  };

  const setRealQuorum = (apartmentsRegistered, totalApartmentsRegistered) => {
    const apartments = apartmentsRegistered.filter(
      (apartment) => apartment.assemblyApartment.userId !== null,
    );
    const realQuorum = apartments
      .reduce(
        (sum, apartment) => sum + apartment.assemblyApartment.coefficient,
        0,
      )
      .toFixed(4);
    const realQuantity = apartments.length;
    const showRealQuorum = realQuantity !== totalApartmentsRegistered;
    setRealQuorumState({
      quorum: realQuorum,
      quantity: realQuantity,
      show: showRealQuorum,
    });
  };

  const options =
    props.assemblyJoints.length &&
    props.assemblyJoints.map((assembly, index) => {
      return (
        <option value={assembly.joint.jointId} key={`${id}-${index}`}>
          {assembly.joint.jointName}
        </option>
      );
    });

  return (
    <>
      {requestState.loading ? (
        <Loading />
      ) : (
        <>
          <section className="userform userform-dashboard" role="form">
            <div className="joint-select-dashboard">
              <select
                className="joint-input userform-select"
                id="joint"
                name="joint"
                data-testid="jointInput"
                {...formik.getFieldProps("jointId")}
              >
                <option value="">{JOINT_INPUT_DEFAULT_OPTION}</option>
                {options}
              </select>
              {requestState.error && (
                <h6 className="bad-request error-message" role="alert">
                  {requestState.error}
                </h6>
              )}
            </div>
            <div className="dashboard-content">
              <table className="dashboard-table">
                <thead
                  className="dashboard-table-header"
                  data-testid="tableHeader"
                >
                  <tr data-testid="rowHeader">
                    <th key={`${id}-1`} data-testid="columnHeader">
                      Quorum <br /> Registrado
                    </th>
                    <th key={`${id}-2`} data-testid="columnHeader">
                      Inmuebles
                    </th>
                  </tr>
                </thead>
                <tbody className="dashboard-table-body" data-testid="tableBody">
                  <tr data-testid="rowBody">
                    <td
                      key={`${id}-registered-quorum`}
                      data-testid="columnBody"
                    >
                      {registerState.quorum}{" "}
                      <span className="quorum-percentage-label">%</span>
                    </td>
                    <td
                      key={`${id}-registered-apartments`}
                      data-testid="columnBody"
                    >
                      {registerState.apartments}
                    </td>
                  </tr>
                </tbody>
              </table>
              {realQuorumState.show && (
                <table className="dashboard-table">
                  <thead
                    className="dashboard-table-header"
                    data-testid="tableHeader"
                  >
                    <tr data-testid="rowHeader">
                      <th key={`${id}-1`} data-testid="columnHeader">
                        Quorum <br /> Actual
                      </th>
                      <th key={`${id}-2`} data-testid="columnHeader">
                        Inmuebles
                      </th>
                    </tr>
                  </thead>
                  <tbody className="dashboard-table-body" data-testid="tableBody">
                    <tr data-testid="rowBody">
                      <td
                        key={`${id}-registered-quorum`}
                        data-testid="columnBody"
                      >
                        {realQuorumState.quorum}{" "}
                        <span className="quorum-percentage-label">%</span>
                      </td>
                      <td
                        key={`${id}-registered-apartments`}
                        data-testid="columnBody"
                      >
                        {realQuorumState.quantity}
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
          </section>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    assemblyJoints: state.assemblyJoints,
    assemblyConcepts: state.assemblyConcepts,
  };
};

const mapDispatchToProps = {
  getAssemblyJointsRequest,
  getAssemblyConceptsRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(AssemblyDashboard);
